<template>
  <vs-table :data="data">
    <template slot="header">
      <div class="con-input-search vs-table--search">
        <input
          class="input-search vs-table--search-input"
          type="text"
          v-model="text"
          @keypress.enter="search"
        />
        <vs-icon icon="search"></vs-icon>
      </div>
      <!-- <vs-button
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="icon-filter"
          class="mx-2"
          radius
          @click="openFilter"
        ></vs-button> -->
    </template>
    <template slot="thead">
      <th-sort
        :text="$t('client')"
        column="Cl.ShortName"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$t('entry_id')"
        column="Cl.ShortName"
        @sort="handleClickSort"
        width="8vw"
      />
      <th-sort
        :text="$t('vendor')"
        column="Cl.ShortName"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$tc('container', 2) | capitalize"
        column="Cl.ShortName"
        @sort="handleClickSort"
        width="10vw"
      />
      <th-sort text="PO" column="Cl.ShortName" @sort="handleClickSort" />
      <th-sort
        :text="$t('aging') | capitalize"
        column="Cl.ShortName"
        @sort="handleClickSort"
        width="7vw"
      />
      <th-sort
        :text="$t('status')"
        column="Cl.ShortName"
        @sort="handleClickSort"
      />
      <th class="qb-sticky">
        {{ $t('actions') }}
      </th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ data[i].client_name }}
        </vs-td>
        <vs-td>
          {{ data[i].entry_id }}
        </vs-td>
        <vs-td>
          {{ data[i].provider_name }}
        </vs-td>
        <vs-td>
          {{ data[i].container_string }}
        </vs-td>
        <vs-td>
          {{ data[i].PO_number }}
        </vs-td>
        <vs-td> {{ data[i].aging }} days </vs-td>
        <vs-td>
          <vs-chip :color="data[i].status_color !== undefined ? data[i].status_color.trim() : '#F4F4F4'">{{
            data[i].status_name
          }}</vs-chip>
        </vs-td>
        <vs-td>
          <div>
            <action-icon
              icon="ArrowRightCircleIcon"
              :tooltip="$t('details')"
              @click="showDetails(data[i].id)"
            />
          </div>
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import ActionPdfViewer from '@/views/components/actions/ActionPdfViewer'
import mixins from '@/mixins'

export default {
  components: {
    ActionIcon,
    ThSort,
    ActionPdfViewer,
  },
  data(){
    return {
      text: ''
    }
  },
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    },
    openFilter() {
      this.$store.dispatch('toggleSidebar', 'entry-filter')
    },
    showDetails(id) {
      this.$router.push({
        name: 'entry-details',
        params: {
          id: id,
        },
      })
    },
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
</style>